import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from "react-intl";

const SelectChargerType = ({ id = "select-charger-type-filter", ...rest }) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     const label = intl.formatMessage
          ? intl.formatMessage({ id: "chargerType", defaultMessage: "Charger Type" })
          : "Charger Type";

     const chargerTypePrefs = userPrefs.get("chargerTypeFilters") || { mounted: false, portable: false };
     const currentValue = chargerTypePrefs.mounted ? "Wall mounted" : chargerTypePrefs.portable ? "Portable" : "all";

     const handleChange = (e) => {
          const selected = e.target.value;
          const newPrefs =
               selected === "Wall mounted"
                    ? { mounted: true, portable: false }
                    : selected === "Portable"
                    ? { mounted: false, portable: true }
                    : { mounted: false, portable: false };
          userPrefs.set({ chargerTypeFilters: newPrefs });
     };

     const optionNames = ["Wall Mounted", "Portable", intl.formatMessage({ id: "all", defaultMessage: "All" })];
     const optionValues = ["Wall mounted", "Portable", "all"];

     return (
          <Select
               id={id}
               value={currentValue}
               label={label}
               optionNames={optionNames}
               optionValues={optionValues}
               handler={handleChange}
               {...rest}
          />
     );
};

export default SelectChargerType;

SelectChargerType.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
};
